import {
  faCog,
  faUser,
  faSpellCheck,
  faGraduationCap,
  faHeading,
  faBrain,
  faFlask,
  faTags,
  faBook,
  faUserGraduate,
  faLanguage,
  faCommentAlt,
  faTable,
  faChartBar,
  faComments,
  faVolumeUp,
  faBookReader,
  faChalkboardTeacher,
  faUpload,
  faFileAlt,
  faClipboardList,
  faClone,
  faIndustry,
  faFont,
  faLink,
  faLayerGroup,
  faBookMedical,
  faClipboardCheck,
  faImages,
  faTools,
  faGlobe,
  faLightbulb,
  faStar,
  faList,
  faQuoteLeft,
  faTableList,
  faAlignLeft,
  faListCheck,
  faSquareCheck,
  faTextHeight,
  faSitemap,

  faStethoscope,
  faCheckDouble,
  faWandMagicSparkles,
  faMicrochip,
  faBookOpen,
  faMobileScreen,
  faPenNib,
} from '@fortawesome/free-solid-svg-icons';
import { faStar as faStarOutline } from '@fortawesome/free-regular-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export const LANGUAGE_FLAGS: { [key: string]: string } = {
  Chinese: 'CN',
  English: 'GB',
  French: 'FR',
  German: 'DE',
  Italian: 'IT',
  Portuguese: 'BR',
  Russian: 'RU',
  Spanish: 'ES',
  Turkish: 'TR',
};

export const MODULE_ICONS: { [key: string]: IconDefinition } = {
  admin: faUser,
  'cl validator': faSpellCheck,
  courses: faGraduationCap,
  headings: faHeading,
  memory: faBrain,
  'tts lab': faFlask,
  'voc. categories': faTags,
  'vocabulary (main)': faBook,
  cat: faLanguage,
  books: faBook,
  trainers: faUserGraduate,
  languages: faLanguage,
  feedback: faCommentAlt,
  literals: faFont,
  tables: faTable,
  charts: faChartBar,
  vocabulary: faBook,
  sentences: faAlignLeft,
  audio: faVolumeUp,
  exercises: faListCheck,
  readings: faBookReader,
  lessons2: faChalkboardTeacher,
  'lessons outline': faSitemap,
  dialogs: faComments,
  publish: faUpload,
  panel: faFileAlt,
  'panel intro': faClipboardList,
  'panel templates': faClone,
  'panels factory': faIndustry,
  'panel titles': faTextHeight,
  inflects: faList,
  conjugations: faTableList,
  compound: faLayerGroup,
  glossary: faBookMedical,
  checker: faClipboardCheck,
  'k-lines': faTags,
  'categories - img': faImages,
  'illustrations bank': faImages,

  'cl utils': faTools,
  items: faQuoteLeft,
  sources: faLanguage,
  segments: faSquareCheck,
  'concept linker': faLink,
  'cultural voc': faGlobe,
  explanations: faLightbulb,
  'lesson titles': faTextHeight,
  health: faStethoscope,
  config: faCog,
  'agent qa': faCheckDouble,
  'ai illustration': faWandMagicSparkles,
  'ai assistant': faMicrochip,
  'knowledge base': faBookOpen,
  translations: faGlobe,
  screenshots: faMobileScreen,
  hanzi: faPenNib,
  'concept tree': faSitemap,
};

export { faStar, faStarOutline };
